import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon/Icon";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DownloadIcon from "@tCentro/Icons/DownloadIcon";
import * as React from "react";
import { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const cart: any = getCurrentCartState(state).value;
    return { cart };
};

export interface CENCartPrintTextStyles {
    DownloadIcon?: InjectableCss;
    container?: InjectableCss;
}

export const CENcartPrintTextStyles: CENCartPrintTextStyles = {
    DownloadIcon: {
        css: css`
            height: auto;
        `,
    },
    container: {
        css: css`
            button[data-test-selector="print"] {
                display: inline-flex;
                -webkit-box-pack: center;
                justify-content: center;
                -webkit-box-align: center;
                align-items: center;
                width: 48px;
                height: 48px;
                border: 2px solid rgb(242, 242, 242);
                border-radius: 40px;
                position: absolute;
                top: 0px;
                background: #f2f2f2;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            right: 18px;
                        `,
                        css`
                            right: 18px;
                        `,
                        css`
                            top: 51px;
                            right: 42px;
                        `,
                        null,
                        null,
                    ])}
                :hover {
                    background: ${getColor("secondary")};
                    border-color: ${getColor("secondary")};
                    svg path {
                        fill: rgb(255, 255, 255);
                    }
                }
            }
        `,
    },
};

const styles = CENcartPrintTextStyles;
// type Props = WidgetProps & HasProduct;
type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasProduct;

const CENCartPrintText: React.FC<Props> = ({ cart }) => {
    if (!cart) {
        return null;
    }

    const printOrOpenPrintAllModal = () => {
        let cart;
        openPrintDialog();
    };

    return (
        <StyledWrapper {...styles.container}>
            <Clickable onClick={printOrOpenPrintAllModal} data-test-selector="print">
                <Icon {...styles.DownloadIcon} src={DownloadIcon} />
            </Clickable>
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CENCartPrintText),

    definition: {
        displayName: "CEN Cart Fine Print Text",
        group: "Cart",
    },
};

export default widgetModule;
